<!--
~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
~ This software is the proprietary information of NEXTWELL INTL SRL.
~ Use is subject to license and non-disclosure terms
-->

@if (state) {
  <div class="notification-panel" @notificationState>
    <div class="d-flex align-items-center d-flex space-between">
      <div class="flex-grow-1 panel-title p">
        <h2> {{'notification-ui.title' | translate}} </h2>
      </div>
      <div class="flex-grow-0 p">
        <button bsButton type="button"
          (click)="reset()" data-testid="reset-btn"><span class="ui-icon-clear" bsButtonIcon></span></button>
        </div>
      </div>
      <div class="notification-container">
        @for (notification of notifications | async; track notification) {
          <div (click)="onNotificationClick(notification)">
            @if (notification.deleted !== true) {
              <div class="notification p" [ngClass]="{'seen': notification.status==='SEEN'}"
                >
                <div class="content">
                  <h3 class="title"> {{notification.subject}} </h3>
                  <p class="body" [innerHTML]="notification.content | safe: 'html'"></p>
                </div>
                <div class="action-wrapper">
                  <button class="action" bsButton type="button"
                    pTooltip="{{'notification-ui.delete' | translate}}"
                    tooltipPosition="left" positionStyle="fixed"
                    (click)="remove($event, notification)" data-testid="remove-btn"><span class="ui-icon-clear" bsButtonIcon></span></button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    <div class="notification-overlay" (click)="reset()"></div>

